module.exports = __webpack_public_path__ + "media/SustainabilityHero.b1c10364.mp4";